// Session cache for the maker-checker action vocabulary.
//
// GET /approval-request-actions returns [{ action, label }] — ~35 entries today,
// growing whenever another operation is put behind maker-checker. It is the
// authority on both halves: `action` is what goes in a `where` clause, `label`
// is what the operator reads. Neither may be hardcoded or derived from the key.
//
// One in-flight promise is shared by every caller and kept for the lifetime of
// the tab, so the list page and its remounts cost a single request. A failed
// fetch is not cached — the next caller retries.

import approvals from '../../services/approvals.service';

let pending = null;

/**
 * @returns {Promise<{ options: Array<{value: string, label: string}>,
 *                     labels: Object<string, string> }>}
 *          `options` feeds the FilterBuilder's action field; `labels` is the
 *          action -> label lookup for the table column.
 */
export function loadActionVocabulary() {
  if (pending) return pending;

  pending = approvals
    .listActions()
    .then((res) => {
      // Already sorted by label server-side — preserve the order received.
      const items = (res && res.data) || [];
      const options = items.map((a) => ({ value: a.action, label: a.label }));
      const labels = {};
      items.forEach((a) => {
        labels[a.action] = a.label;
      });
      return { options, labels };
    })
    .catch((err) => {
      pending = null; // don't cache a failure
      throw err;
    });

  return pending;
}

// Test/debug escape hatch — drops the cached vocabulary.
export function resetActionVocabulary() {
  pending = null;
}
